import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoTimePickerMixin from './KendoTimePickerMixin'

export default {
    name: 'kendo-timepicker',
    mixins: [ KendoTimePickerMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('input',{
            props: {
                value: this.value
            }
        })
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoTimePicker/index.js